export default __webpack_public_path__ + "static/media/Nihilistic Pants.8844dda2.jpg";